module.exports = __webpack_public_path__ + "static/media/book-1.cf2638fa.png";